import moment from 'moment-timezone'

export const formatMinutesAsTime = minutesFromMidnight => {
  const hours = Math.floor(minutesFromMidnight / 60)
    .toString()
    .padStart(2, '0')
  const minutes = (minutesFromMidnight % 60).toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

export const convertLocalIssueTimeToUtc = (
  localMinutes,
  referenceDate,
  timezone,
) => {
  const localDate = moment(referenceDate).format('YYYY-MM-DD')
  const utcDateTime = moment
    .tz(localDate, 'YYYY-MM-DD', timezone)
    .startOf('day')
    .add(localMinutes, 'minutes')
    .utc()

  return {
    date: utcDateTime.format('YYYY-MM-DD'),
    minutes: utcDateTime.hours() * 60 + utcDateTime.minutes(),
  }
}
